import { api, FormatResponse } from '../index';
const SFDC_DELEGATE_URL = '/api/salesforce/delegate';

export const delegateSaleForce = async (params) => {
        const delegateRes = await api.get(SFDC_DELEGATE_URL, { params });
        return new FormatResponse(delegateRes);
};
        